import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "button", "message", "prompt", "success", "checkoutButton", "checkoutMessage"]
  static values = { url: String, checkoutUrl: String }

  submit(event) {
    event.preventDefault()

    const value = this.inputTarget.value.trim()
    if (!value) {
      this.showMessage("Please enter your email or phone number.", "text-red-600")
      return
    }

    const isEmail = value.includes("@")
    const body = isEmail ? { email: value } : { phone: value }

    this.buttonTarget.disabled = true
    this.buttonTarget.textContent = "Sending..."

    fetch(this.urlValue, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content
      },
      body: JSON.stringify(body)
    })
      .then(response => response.json().then(data => ({ ok: response.ok, data })))
      .then(({ ok, data }) => {
        if (ok && data.refilled) {
          this.promptTarget.classList.add("hidden")
          this.successTarget.classList.remove("hidden")

          const gaugeController = this.application.getControllerForElementAndIdentifier(
            this.element, "ai-credit-gauge"
          )
          if (gaugeController) {
            gaugeController.remainingValue = data.remaining
            gaugeController.totalValue = data.total
            gaugeController.percentageValue = data.percentage
          }

          const countEl = this.element.querySelector('[data-ai-credit-gauge-target="count"]')
          if (countEl) countEl.textContent = `${data.remaining}/${data.total}`

          const fillEl = this.element.querySelector('[data-ai-credit-gauge-target="fill"]')
          if (fillEl) fillEl.style.width = `${data.percentage}%`
        } else {
          this.showMessage(data.error || "Something went wrong.", "text-red-600")
          this.buttonTarget.disabled = false
          this.buttonTarget.textContent = "Get Credits"
        }
      })
      .catch(() => {
        this.showMessage("Network error. Please try again.", "text-red-600")
        this.buttonTarget.disabled = false
        this.buttonTarget.textContent = "Get Credits"
      })
  }

  checkout(event) {
    event.preventDefault()

    if (!this.hasCheckoutUrlValue) {
      this.showCheckoutMessage("Checkout is unavailable right now.", "text-red-600")
      return
    }

    if (this.hasCheckoutButtonTarget) {
      this.checkoutButtonTarget.disabled = true
      this.checkoutButtonTarget.textContent = "Redirecting..."
    }

    fetch(this.checkoutUrlValue, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content,
        "Accept": "application/json"
      },
      body: JSON.stringify({})
    })
      .then(response => response.json().then(data => ({ ok: response.ok, data })))
      .then(({ ok, data }) => {
        if (ok && data.url) {
          window.location.href = data.url
          return
        }

        this.showCheckoutMessage(data.error || "Unable to start checkout.", "text-red-600")
        if (this.hasCheckoutButtonTarget) {
          this.checkoutButtonTarget.disabled = false
          this.checkoutButtonTarget.textContent = "Buy 300 Credits"
        }
      })
      .catch(() => {
        this.showCheckoutMessage("Network error. Please try again.", "text-red-600")
        if (this.hasCheckoutButtonTarget) {
          this.checkoutButtonTarget.disabled = false
          this.checkoutButtonTarget.textContent = "Buy 300 Credits"
        }
      })
  }

  showMessage(text, colorClass) {
    this.messageTarget.textContent = text
    this.messageTarget.className = `text-xs mt-1 ${colorClass}`
    this.messageTarget.classList.remove("hidden")
  }

  showCheckoutMessage(text, colorClass) {
    if (!this.hasCheckoutMessageTarget) return

    this.checkoutMessageTarget.textContent = text
    this.checkoutMessageTarget.className = `text-xs mt-1 ${colorClass}`
    this.checkoutMessageTarget.classList.remove("hidden")
  }
}
